import type { Customer } from '@/types';

export const customers: Customer[] = [
  {
    id: 'C-1001',
    name: 'Ayşe Yılmaz',
    phone: '0532 456 78 90',
    region: 'İstanbul Anadolu',
    address: 'Beykoz, Kavacık Mah. No:12',
    status: 'Aktif',
    lastService: 'Villa Detaylı Temizlik',
    totalJobs: 4,
    lastContact: 'Bugün 09:10',
    source: 'Referans',
  },
  {
    id: 'C-1002',
    name: 'Mehmet Demir',
    phone: '0533 214 55 87',
    region: 'Silivri',
    address: 'Silivri, Selimpaşa Cad. No:88',
    status: 'Aktif',
    lastService: 'İnşaat Sonrası Temizlik',
    totalJobs: 2,
    lastContact: 'Bugün 08:40',
    source: 'WhatsApp',
  },
  {
    id: 'C-1003',
    name: 'Selin Kaya',
    phone: '0542 789 32 11',
    region: 'İstanbul Anadolu',
    address: 'Ataşehir, Atatürk Mah. No:3',
    status: 'Aktif',
    lastService: 'Residence Temizliği',
    totalJobs: 3,
    lastContact: '2 gün önce',
    source: 'Instagram',
  },
  {
    id: 'C-1004',
    name: 'Ahmet Çelik',
    phone: '0535 321 90 44',
    region: 'İstanbul Avrupa',
    address: 'Kadıköy, Moda Cad. No:21',
    status: 'Yeni',
    lastService: 'Plaza / Ofis Temizliği',
    totalJobs: 1,
    lastContact: 'Dün 17:20',
    source: 'Website',
  },
  {
    id: 'C-1005',
    name: 'Zeynep Arslan',
    phone: '0536 678 12 09',
    region: 'Tekirdağ',
    address: 'Tekirdağ, Çorlu Merkez No:5',
    status: 'Yeni',
    lastService: 'Yazlık Ev Temizliği',
    totalJobs: 0,
    lastContact: 'Dün 11:05',
    source: 'Facebook',
  },
  {
    id: 'C-1006',
    name: 'Murat Öztürk',
    phone: '0541 902 67 31',
    region: 'Ankara',
    address: 'Ankara, Çankaya No:19',
    status: 'Aktif',
    lastService: 'Koltuk Yıkama',
    totalJobs: 2,
    lastContact: '3 gün önce',
    source: 'Referans',
  },
  {
    id: 'C-1007',
    name: 'Elif Doğan',
    phone: '0537 450 88 26',
    region: 'İstanbul Anadolu',
    address: 'Üsküdar, Kuzguncuk No:7',
    status: 'Aktif',
    lastService: 'Villa Temizliği',
    totalJobs: 5,
    lastContact: 'Bugün 07:55',
    source: 'WhatsApp',
  },
  {
    id: 'C-1008',
    name: 'Can Aksoy',
    phone: '0538 123 74 58',
    region: 'İstanbul Avrupa',
    address: 'Beşiktaş, Levent No:44',
    status: 'Pasif',
    lastService: 'Residence Temizliği',
    totalJobs: 1,
    lastContact: '1 hafta önce',
    source: 'Instagram',
  },
  {
    id: 'C-1009',
    name: 'Fatma Şahin',
    phone: '0539 876 40 93',
    region: 'İstanbul Avrupa',
    address: 'Büyükçekmece, Mimar Sinan No:2',
    status: 'Aktif',
    lastService: 'Yazlık Ev Temizliği',
    totalJobs: 3,
    lastContact: 'Dün 15:30',
    source: 'Facebook',
  },
  {
    id: 'C-1010',
    name: 'Emre Korkmaz',
    phone: '0544 567 29 18',
    region: 'İstanbul Avrupa',
    address: 'Şişli, Nişantaşı No:9',
    status: 'Yeni',
    lastService: 'Plaza / Ofis Temizliği',
    totalJobs: 0,
    lastContact: 'Bugün 06:20',
    source: 'Manuel',
  },
];